import { alpha } from '@mui/material';
import { buttonClasses } from '@mui/material/Button';
import type { Theme } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  mainCard: {
    width: '98%',
    margin: '20px 20px 30px 20px',
    padding: '0 0 0 0',
    height: '100%',
    overflowY: 'scroll',
  },
  tableCard: {
    width: '100%',
    margin: '30px',
    padding: '10px',
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px 0 10px 30px',
    width: '80%',
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1001,
  },
  topSectionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  addUserButton: {},
  profileUserName: {
    cursor: 'pointer',
  },
  tableContainer: {},
  tableRow: {
    '& td, & th': {
      border: 0,
    },
  },
  input: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: '5px',
    width: '100%',
    marginBottom: '10px',
    padding: '5px 7px',
  },

  moreVertButton: {
    cursor: 'pointer',
  },
  tableActionButton: {
    [`&.${buttonClasses.text}`]: {
      textTransform: 'none',
      color: alpha(theme.palette.common.white, 0.4),
    },
  },
  tableCell: {
    [`&.${tableCellClasses.head}`]: {
      color: alpha(theme.palette.common.white, 0.4),
      textAlign: 'left',
    },
    [`&.${tableCellClasses.body}`]: {
      color: theme.palette.common.white,
      textAlign: 'left',
    },
  },
}));

export default useStyles;
